import { parseString } from "xml2js";
import _ from "lodash";
import decode from "jwt-decode";
import { isNumber } from "util";
import {
  USER_LOGGED_IN,
  USER_LOGGED_OUT,
  USER_SESSION_EXPIRED,
  ADD_USER_ACCOUNT,
} from "../types";
import {
  ERR_MSG_INVALID_PASSWORD,
  ERR_MSG_PASSWORD_EXPIRED,
  ERR_MSG_SESSION_EXPIRED,
} from "../ErrorMessages";
import api from "../api";
import setAuthorizationHeader from "../utils/setAuthorizationHeader";
import { setAppErrorMessage } from "../actions/appMessage";
import { setUserAccount } from "../metadata/userAccount";
import { getLoginMessage } from "../components/messages/errorMessages";
import settings from "../settings";
import { UNABLE_TO_FETCH } from "../utils/errorUtil";

export const userSecCheck = (user) => ({
  type: USER_LOGGED_IN,
  user,
});

export const userLoggedIn = (user) => ({
  type: USER_LOGGED_IN,
  user,
});

export const userSessionExpired = () => ({
  type: USER_SESSION_EXPIRED,
});

export const userLoggedOut = () => ({
  type: USER_LOGGED_OUT,
});

export const addUserAccount = (userAccount) => ({
  type: ADD_USER_ACCOUNT,
  userAccount,
});

function processSession(res, dispatch) {
  if (res.status === 200) {
    parseString(
      res.data,
      { async: false, rootName: "result", xmldec: { encoding: "utf-16" } },
      (err, result) => {
        if(result == null) {
            dispatch(setAppErrorMessage(UNABLE_TO_FETCH))
            return;
        }        
        localStorage.appToken = _.get(result.result, "token[0]", "");
        if (localStorage.appToken !== "") {
          const nonAuthHost = _.get(result.result, "data[0].nonAuthHost[0]");
          localStorage.requestUri = `https://${nonAuthHost}`;
          setUserAccount(result);
        } else {
          const status = _.get(result.result, "status[0]", "");
          if (status === "EXPIRED") {
            localStorage.loginFailed = ERR_MSG_PASSWORD_EXPIRED;
            window.location.href = `./forgotpassword`;
          } else {
            const attemptCounter = _.get(
              result.result,
              "data[0].loginattempt[0]",
              ""
            );
            const message = getLoginMessage(status, attemptCounter);
            if (message !== "") dispatch(setAppErrorMessage(message));
            else dispatch(setAppErrorMessage(ERR_MSG_INVALID_PASSWORD));
          }
        }
      }
    );
    return Promise.resolve(res);
  }
  return Promise.resolve(res);
}

export const login = (credentials) => (dispatch) =>
  api.user.login(credentials).then((res) => processSession(res, dispatch));

export const getUserSession = (sessionId) => (dispatch) =>
  api.user.userSession(sessionId).then((res) => processSession(res, dispatch));

const clearLocalStorage = () => {
  localStorage.clear();
};

export const logout = (userid) => (dispatch) => {
  clearLocalStorage();
  setAuthorizationHeader();
  dispatch(userLoggedOut());
  api.user.logout({ username: userid });
};

export const expireSession = (errorMessage = ERR_MSG_SESSION_EXPIRED) => (
  dispatch
) => {
  if (!localStorage.appToken) return;
  clearLocalStorage();
  setAuthorizationHeader();
  dispatch(setAppErrorMessage(errorMessage));
  dispatch(userSessionExpired());
  dispatch(userLoggedOut());
};

export const getSecQuestions = () => () => api.user.getSecQuestions();

// export const checkSec = payload => () => api.user.checkSec(payload);

export const checkSec = (payload) => () =>
  api.user.checkSec(payload).then((res) => {
    localStorage.removeItem("sessionID");
    if (res.status === 200 && res.data.Status) {
      localStorage.sessionID = res.data.LogId;
    }
    return Promise.resolve(res);
  });

const getTokenExpirationDate = (encodedToken) => {
  if (
    encodedToken === null ||
    encodedToken === undefined ||
    encodedToken === ""
  ) {
    return null;
  }
  const token = decode(encodedToken);
  if (!token.exp) {
    return null;
  }
  const curDate = new Date();
  curDate.setMilliseconds(0);
  curDate.setMinutes(curDate.getMinutes() + (token.exp - token.iat) / 60);
  return curDate;
};

export const renewUserToken = () => {
  const expireTime = localStorage.expires;
  if (expireTime) {
    const date = new Date(0);
    date.setSeconds(expireTime);
    const renewalTime = Number(date.getTime()) - 5 * 60 * 1000;
    const currentUtcTime = new Date().getTime();
    if (renewalTime < currentUtcTime) {
      api.user
        .renewToken({
          sessionId: localStorage.sessionID,
          appName: settings.appName,
        })
        .then((res) => {
          if (
            res.status === 200 &&
            res.data &&
            res.data.Token &&
            res.data.Token !== null
          ) {
            localStorage.appToken = res.data.Token;
            const token = decode(res.data.Token);
            const curDate = new Date();
            curDate.setMilliseconds(0);
            curDate.setMinutes(curDate.getMinutes() + (token.exp - token.iat) / 60);
            localStorage.expires = curDate.getTime() / 1000;
            setAuthorizationHeader(localStorage.appToken);
          } else {
            expireSession();
          }
        });
    }
  }
};

export const isTokenValid = () => () => {
  renewUserToken();
  const expire = getTokenExpirationDate(localStorage.appToken);
  return (
    !!localStorage.appToken &&
    !!expire &&
    Number(expire.getTime()) > Number(new Date().getTime())
  );
};

export const validateSecurityToken = (securityToken, appname) => () =>
  api.user.validateSecurityToken(securityToken, appname).then((res) => {
    localStorage.removeItem("sessionID");
    if (res.status === 200 && res.data.Status) {
      localStorage.sessionID = res.data.LogId;
    }
    return Promise.resolve(res);
  });

export const isUserLoggedIn = () => () =>
  localStorage.sessionID &&
  localStorage.sessionID !== "" &&
  isNumber(localStorage.sessionID);

export const isTokenExpired = () => {
  const expire = getTokenExpirationDate(localStorage.appToken);
  return (
    !!localStorage.appToken &&
    !!expire &&
    Number(expire.getTime()) < Number(new Date().getTime())
  );
};



// WEBPACK FOOTER //
// ./src/actions/auth.js